export const CATEGORY_META = [
  { key: 'seasonality', label: '旬・推し',       color: '#3a6644' },
  { key: 'popularity',  label: '人気',           color: '#d4762a' },
  { key: 'rarity',      label: '珍しさ',         color: '#8a6858' },
  { key: 'balance',     label: 'セットバランス', color: '#5a6e9a' },
  { key: 'duplication', label: '重複状況',       color: '#7a8a78' },
]

export function scoreColor(v, C) {
  if (v == null) return C.inkMuted
  const p = v * 100
  return p >= 80 ? C.greenDark : p >= 70 ? C.gold : p >= 60 ? C.carrot : C.tomato
}

export function fmtScore(v) {
  return v != null ? Math.round(v * 100) : '—'
}

export default function BreakdownScoreBar({ value, breakdown, C, height = 28, showTotal = true }) {
  const score = value != null ? Math.round(value * 100) : 0
  const color = scoreColor(value, C)
  const hasBreakdown = breakdown && CATEGORY_META.some(c => (breakdown[c.key] || 0) > 0)
  return (
    <div style={{ flex: 1, minWidth: '160px' }}>
      {hasBreakdown ? (
        <div style={{ display: 'flex', height: `${height}px`, borderRadius: '5px', overflow: 'hidden', background: C.lineSoft, gap: '1px' }}>
          {CATEGORY_META.map(cat => {
            const pts = breakdown[cat.key] || 0
            if (!pts) return null
            const widthPct = pts
            return (
              <div key={cat.key} title={`${cat.label}: ${pts.toFixed(1)}pt`}
                style={{ width: `${widthPct}%`, background: cat.color, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                {widthPct > 6 && (
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '10px', fontWeight: 700, color: '#fff', whiteSpace: 'nowrap', textShadow: '0 1px 2px rgba(0,0,0,0.4)' }}>
                    {pts.toFixed(0)}
                  </span>
                )}
              </div>
            )
          })}
          <div style={{ flex: 1, background: C.lineSoft }} />
        </div>
      ) : (
        <div style={{ height: `${height}px`, background: C.lineSoft, borderRadius: '5px', overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
          <div style={{ height: '100%', width: `${score}%`, background: color, borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: '6px' }}>
            <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '10px', fontWeight: 700, color: '#fff' }}>{score}</span>
          </div>
        </div>
      )}
      {showTotal && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '3px' }}>
          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '11px', color }}>
            {fmtScore(value)} / 100
          </span>
        </div>
      )}
    </div>
  )
}
